"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const reusables_1 = require("../../../comps/reusables");
exports.Nav = ({ activeTab, userId, basePath }) => {
    return (react_1.default.createElement(reusables_1.NavPills, { center: true, activeTab: activeTab, queryDetailLayout: true, tabs: [
            {
                id: 'profile',
                name: 'Profile',
                to: `${basePath.replace(':id', `${userId}`)}`,
            },
            {
                adminRole: 'app',
                id: 'Admin',
                name: 'Admin',
                to: `${basePath.replace(':id', `${userId}`)}/admin`,
            },
            {
                adminRole: 'app',
                id: 'invites',
                name: 'Invites',
                to: `${basePath.replace(':id', `${userId}`)}/invites`,
            },
        ] }));
};
//# sourceMappingURL=Nav.js.map